import React from 'react';
import { CardBenefit } from '@components/CardBenefit/CardBenefit';
import { BenefitHighlightBlockType } from '@appTypes/BenefitHighlightBlockType';
import { ModularButton } from '@components/ModularButton/ModularButton';
import * as S from './Styles';

interface Props {
  block: BenefitHighlightBlockType;
}

export const MembershipBenefitHighlightListBlock = ({ block }: Props) => {
  const { membershipBenefitHighlightsList, title, variant, modularButtons, hasModularButtons } = block;
  return (
    <S.BenefitHighlights>
      {title && <h2>{title}</h2>}
      <S.HighlightList $modularButtons={!!modularButtons?.primaryButton?.buttonText}>
        {membershipBenefitHighlightsList?.map((highlight) => (
          <CardBenefit
            key={highlight.id}
            title={highlight.title}
            description={highlight.description}
            variant={variant}
            image={highlight.image}
            link={highlight.link}
            id={highlight.id}
          />
        ))}
      </S.HighlightList>
      {hasModularButtons && modularButtons.primaryButton?.buttonText ? (
        <ModularButton primaryButton={modularButtons.primaryButton} secondaryButton={modularButtons.secondaryButton} />
      ) : null}
    </S.BenefitHighlights>
  );
};
